import { Footer } from 'shared/layout/footer';
import { Navbar } from './navbar';
import { FC, useEffect, useState } from 'react';
import DashboardConfig from 'shared/layout/dashboard.config';
import { ContentField, TotalScore, MainField, Score, ScoreButton } from './dashboard-layout.style';
import Sidebar from './sidebar/sidebar';
import type { DashboardLayoutProps } from 'shared/types/layout.type';
import { useBreakpoint } from 'shared/hooks';
import { useSearchParams } from 'react-router-dom';
import resources from './loc';
import { useTranslationNamespace } from 'shared/helper/app-helper';

const DashboardLayout: FC<DashboardLayoutProps> = ({ children, dashboardType: dashboard, footerDisplay = false }) => {
	const config = DashboardConfig();
	const isTablet = useBreakpoint('max', 'xl');
	const [searchParams] = useSearchParams();
	const { ready } = useTranslationNamespace('layout', resources);
	useEffect(() => {
		const referral_id = searchParams.get('referralId');
		if (referral_id) {
			localStorage.setItem('referralId', referral_id);
		}
	}, [searchParams.get('referralId')]);

	return ready ? (
		<>
			<Navbar />
			<MainField>
				{isTablet ? null : (
					<div>
						<Sidebar data={config[dashboard]} />
					</div>
				)}
				<ContentField>{children}</ContentField>
			</MainField>
			{footerDisplay && <Footer />}
		</>
	) : (
		<></>
	);
};

export default DashboardLayout;
